module.exports = __webpack_public_path__ + "img/logo.0a6aef8e.svg";